import { useQuery } from '@tanstack/react-query';

import { useApi } from '@/context';

export const regionKeys = {
    all: ['regions'] as const,
    list: () => [...regionKeys.all, 'list'] as const,
};

export function useRegions() {
    const api = useApi();

    return useQuery({
        queryKey: regionKeys.list(),
        queryFn: () => api.regions.getRegions(),
    });
}
